export default __webpack_public_path__ + "static/media/facebook-icon.6f0e402d.svg";